import React from "react";
import { Image } from "semantic-ui-react";
import { DataField } from "components/displays";
import DefaultPrincipalLogo from "assets/logos/principal-logo.svg";
import { CalcTypeDescription } from "features/../../../shared/constants/enums";

const OfficeHeader = ({ data }) => {
  return (
    <div className="content-panel">
      <div className="office-header">
        <div className="office-header-group group1">
          {DataField("Name", data.name)}
          {DataField("Head Office", data.dealerName)}
        </div>
        <div className="office-header-group group2">
          {DataField("Contact Phone", data.contactPhone)}
          {DataField("Contact Email", data.contactEmail)}
        </div>
        <div className="office-header-group group3">
          {DataField("Construct Description", data.description)}
          {DataField("Calc Type", CalcTypeDescription[data.calcType])}
        </div>
        <div className="office-header-group group4">
          <Image
            className="office-logo"
            src={data.logoUri || DefaultPrincipalLogo}
            alt="Supplier Logo"
            title="Supplier Logo"
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeHeader;
